module.exports = __webpack_public_path__ + "8a555a96a9940a7ac242a114d9a21a03.svg";